/*jshint esversion: 9 */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import authReducer from './store/reducers/auth';
//import configReducer from './store/reducers/config';
import transReducer from './store/reducers/transactions';
// import { doLog, initializeLogging, Log, setLogging } from './shared/utility';
import { doLog, setLogging } from './shared/utility';

//Use const composeEnhancers = compose; for production or when the Redux DevTools extension is not installed:
// const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;
const composeEnhancers = compose;

const rootReducer = combineReducers({
    auth: authReducer,
    //config: configReducer,
    trans: transReducer
});
const store = createStore( rootReducer, composeEnhancers(
    applyMiddleware(thunk)
) );

// const serverAppPath = "citizenweb";
const serverAppPath = "ecop";

let pathname = window.location.pathname;
let agencyCode = "";
let basename = "";
let remoteLogging = false;
let productionMode = false;
let dologging = false;

console.log("[index] pathname:" + pathname);

let pos = pathname.indexOf('index.html');
if (pos !== -1) {
    //if (doLog()) console.log('[index] pos:' + pos);
    let startPos = pathname.lastIndexOf('/', pos-2);
    //if (doLog()) console.log('[index] startPos:' + startPos);
    if (startPos !== -1) {
        agencyCode = pathname.substring(startPos+1, pos-1);
    }
} else {
    let startPos = pathname.lastIndexOf('/');
    //if (doLog()) console.log('[index] startPos:' + startPos);
    if (startPos !== -1)
    agencyCode = pathname.substring(startPos+1);
}

//if (agencyCode.toLowerCase() === "citizenweb") {
if (agencyCode.toLowerCase() === serverAppPath) {
    agencyCode = "";
}

//********* Change between development and deployment *************************
productionMode = false;
dologging = true;
//*****************************************************************************

if (productionMode) {
    // basename = "/ecop/" + agencyCode; //Use for deployment
    // basename = "/" + serverAppPath + "/" + agencyCode; //Use for deployment
    basename = "/" + agencyCode; //Use for development
    // remoteLogging = true;
} else {
    basename = "/" + agencyCode; //Use for development
    remoteLogging = false;
}

// remoteLogging = true;

// initializeLogging(agencyCode, remoteLogging, productionMode);
setLogging(dologging);
if (doLog()) console.log('[index] pathname:' + pathname);
if (doLog()) console.log('[index] agencyCode:' + agencyCode);
if (doLog()) console.log('[index] basename:' + basename);
if (doLog()) console.log('[index] productionMode:' + productionMode);
if (doLog()) console.log('[index] remoteLogging:' + remoteLogging);

const app = (
    <Provider store={store}>
        <BrowserRouter basename={basename}>
            <App agencyCode={agencyCode} serverAppPath={serverAppPath} productionMode={productionMode} />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render( app, document.getElementById('root') );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
